import { ISpamEntry } from "store/entities/spam/interfaces";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const deserializeEntry: (object: any) => ISpamEntry = object => {
  const { ID, email } = object;

  return {
    id: ID,
    value: email,
  };
};
